module.exports = __webpack_public_path__ + "img/24.73386571.jpg";